import Ls from '@/services/ls'
import * as types from './mutation-types'

export const loadQuestions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`nsp/get/questions`).then((response) => {
            commit(types.LOAD_QUESTIONS, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadQuestion = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`nsp/how/${id}/question`).then((response) => {
            commit(types.LOAD_QUESTION, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}


export const storeQuestion = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('nps/question/store', data).then((response) => {
            resolve(response)
            commit(types.ADD_QUESTION, response.data.question)
        }).catch(err => {
            reject(err)
        })
    })
}


export const updateQuestion = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('nps/question/' + data.id + '/update', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteQuestion = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('nps/question/' + id + '/delete').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const setVisibleQuestion = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('setVisible/' + data.id +'/question', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}